import { freightPickupWindowIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const setDefaultFreightPickupWindow = {
  name: "setDefaultFreightPickupWindow" as const,
  input: z.object({ id: freightPickupWindowIdFormat.schema }),
  output: z.object({}),
};
